import { Component, Input, OnInit } from '@angular/core';
import { itemTypeIcons, itemTypeLabel } from 'app/constants/itemType.constants';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-authorization-sales-code-assignment',
    templateUrl: './authorization-sales-code-assignment.component.html',
    styleUrls: ['./authorization-sales-code-assignment.component.scss'],
})
export class AuthorizationSalesCodeAssignmentComponent implements OnInit {
    @Input() services: any;
    @Input() isFinalizedRo: boolean = false;
    @Input() assignedSalesCodeItems: any[] = [];
    @Input() type: string = 'sales-code';

    typeMap: any = itemTypeLabel;
    iconMap: any = itemTypeIcons;

    subscription: Subscription;

    warrantyOptions = [
        { _id: 1, title: 'No Warranty', type: "not-warranty" },
        { _id: 2, title: 'First Time Installation', type: "first-time" },
        { _id: 3, title: 'Warranty Replacement', type: "replacement" }
    ];

    constructor() { }

    ngOnInit(): void {
    }


    getWarrantyLabel(warranty) {
        const warrantyLabel = this.warrantyOptions.find(option => option?.type ===
            warranty?.type)
        return warrantyLabel?.title || '';
    }

}